export default "__VITE_ASSET__ea7fdd67__"